import * as yup from 'yup'
import { INewContact } from 'apps/fleet-planner/schema/ContactSchema'
import { ContactSchemaWithRequired } from 'apps/fleet-planner/schema/ContactSchemaWithRequired'
import { INewCustomer } from 'apps/fleet-planner/schema/CustomerSchema'

export interface INewContactWithNotes extends Pick<INewCustomer, 'notes'> {
  contact: INewContact
}

/**
 * Creates new contact, and also send a notes values
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Contacts/post_customers__id__contacts
 */
export const ContactWithNotesSchema = yup.object<INewContactWithNotes>({
  notes: yup.string().notRequired(),
  contact: ContactSchemaWithRequired,
})

export type ContactWithNotesSchemaType = yup.InferType<typeof ContactWithNotesSchema>
